import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ChevronDown } from '@yme/assets/icons';
import { Container } from '@yme/atoms/grid';
import { useMenuHeight } from '@yme/hooks/index';
import { CollapsingButtonStyled, StickyFilterStyled, RowStyled, RowContentStyled } from './styled';
export function StickyFilter({ children, collapsedContent, hasCollapsingButton = false, isSticky, isRightToLeft, }) {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const headerMenuHeight = useMenuHeight();
    const onCollapsedClickHandle = useCallback(() => {
        setIsCollapsed(!isCollapsed);
    }, [isCollapsed]);
    useEffect(() => {
        if (!isSticky) {
            setIsCollapsed(true);
        }
    }, [isSticky]);
    return createPortal(React.createElement(StickyFilterStyled, { isSticky: isSticky, headerMenuHeight: headerMenuHeight },
        React.createElement(Container, { isRightToLeft: isRightToLeft },
            React.createElement(RowStyled, null,
                children,
                hasCollapsingButton && (React.createElement(CollapsingButtonStyled, { iconType: ChevronDown, iconRotate: isCollapsed ? 0 : 180, isPaddingsReset: true, onClick: onCollapsedClickHandle }))),
            !isCollapsed && (React.createElement(RowContentStyled, { isRightToLeft: isRightToLeft }, collapsedContent)))), document.body);
}
